import React, { forwardRef } from 'react'
import clsx from 'clsx'

import { useSiteContext } from '@contexts/MkSiteContext'
import './Card.scss'

export interface ICard {
  inversed?: boolean
  subtone?: boolean
  transparent?: boolean
  innerClassName?: string
}

export interface CardProps {
  children?: React.ReactNode
  className?: string
  /** When `true`, applies the standard surface box shadow. */
  elevated?: boolean
  inversed?: boolean
  subtone?: boolean
  innerClassName?: string
  transparent?: boolean
  backgroundType?: 'dots' | 'lines' | string
  backgroundPosition?: 'right' | 'left' | 'center' | string
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    { children, className, innerClassName, elevated, inversed, subtone, transparent, backgroundType, backgroundPosition },
    ref,
  ) => {
    const { themeBrand: brand } = useSiteContext()

    if (brand === 'sir' && backgroundType === 'dots') {
      require(`./Card_sir.scss`)
    }

    if (brand === 'ebac') {
      require(`./Card_ebac.scss`)
    }

    /** EBAC: inversed surfaces use an inner border + padding (see `Card_ebac.scss`). */
    const useEbacInversedLayer = brand === 'ebac' && inversed

    const cardCardClasses = {
      card: true,
      'card--inversed': inversed && !subtone,
      'card--inversed-subtone': inversed && subtone,
      'card--subtone': subtone && !inversed,
      'card--transparent': transparent && !inversed && !subtone,
      'card--elevated': elevated,
      'card--background-dots': backgroundType === 'dots',
      [`card--background-position-${backgroundPosition}`]: backgroundPosition,
    }

    if (useEbacInversedLayer) {
      return (
        <div
          ref={ref}
          className={clsx(cardCardClasses, className)}>
          <div className={clsx('card__inner', innerClassName)}>{children}</div>
        </div>
      )
    }

    return (
      <div
        ref={ref}
        className={clsx(cardCardClasses, className)}>
        {children}
      </div>
    )
  },
)

export default Card
